module.exports = __webpack_public_path__ + "img/tiktok-icon.40789cb4.png";